import axios from "axios";
import store from "../redux/store";
import { showToastAction } from "../redux/toastSlice";

export default async function getDocumentsDynamicDisplay(projectName, formName, document_id) {
    try {
        return await axios.get(`/project/${projectName}/${formName}/Document/${document_id}/dynamic-display`)
    }
    catch (err) {
        store.dispatch(showToastAction({ message: err.response?.data?.errorMessage ?? "Error", showToast: true }))
    }
}